export const rxGeneratedToday = [
  { time: "13:00", count: 6 },
  { time: "13:30", count: 3 },
  { time: "14:00", count: 8 },
  { time: "14:30", count: 5 },
  { time: "15:00", count: 10 },
  { time: "15:30", count: 7 },
  { time: "16:00", count: 12 },
  { time: "16:30", count: 9 },
  { time: "17:00", count: 11 },
  { time: "17:30", count: 4 },
  { time: "18:00", count: 9 },
  { time: "18:30", count: 11 },
  { time: "19:00", count: 10 },
];

export const prescriptionCounts = {
  pending: 8,
  ready: 8,
  refills: 5,
};

export const shiftInfo = {
  remainingHours: 2,
};

export const userInfo = {
  name: "Vishal",
};